
(function () {
  'use strict';

  var ROOT_MARGIN = '0px 0px 600px 0px';

  function str(key, fallback, vars) {
    if (window.t) return window.t(key, fallback, vars);
    var s = fallback;
    Object.keys(vars || {}).forEach(function (k) {
      s = s.split('__' + k + '__').join(vars[k]);
    });
    return s;
  }

  function toInt(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  function sectionUrl(pageUrl, sectionId) {
    var url;
    try {
      url = new URL(pageUrl, window.location.href);
    } catch (e) {
      return null;
    }
    if (url.origin !== window.location.origin) return null;
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  function setup(root) {
    if (root.dataset.paginationReady) return;

    var scope = root.closest('.shopify-section') || document;
    var grid = scope.querySelector('[data-product-grid]');
    var nav = scope.querySelector('[data-pagination]');
    var button = root.querySelector('[data-pagination-more]');
    var status = root.querySelector('[data-pagination-status]');
    var bar = root.querySelector('[data-pagination-bar]');
    var errorBox = root.querySelector('[data-pagination-error]');
    var errorText = root.querySelector('[data-pagination-error-text]');
    var retry = root.querySelector('[data-pagination-retry]');
    var sectionId = root.dataset.sectionId;
    var nextUrl = nav ? nav.getAttribute('data-next-url') || '' : '';

    if (!grid || !nav || !button || !status || !sectionId || !nextUrl) return;
    root.dataset.paginationReady = 'true';

    var style = root.dataset.style === 'load_more' ? 'load_more' : 'infinite';
    var autoPages = Math.max(0, toInt(root.dataset.autoPages, 3));
    var total = toInt(root.dataset.total, 0);
    var shown = toInt(root.dataset.shown, grid.querySelectorAll('.product-card').length);
    var offset = toInt(root.dataset.offset, 0);
    var results = root.dataset.kind === 'results';

    var moreLabel = button.textContent.trim();
    var loadingLabel = str('pagination_loading', 'Loading…');

    var errorMessage = errorText ? errorText.textContent.trim() : '';
    if (errorText) errorText.textContent = '';

    var loading = false;
    var failed = false;
    var autoLoaded = 0;
    var observer = null;

    function statusText() {
      var vars = { SHOWN: shown, TOTAL: total };
      if (!nextUrl && offset === 0) {
        return results
          ? str('pagination_all_results_shown', 'All __TOTAL__ results shown', vars)
          : str('pagination_all_shown', 'All __TOTAL__ products shown', vars);
      }
      return results
        ? str('pagination_showing_results', 'Showing __SHOWN__ of __TOTAL__ results', vars)
        : str('pagination_showing', 'Showing __SHOWN__ of __TOTAL__ products', vars);
    }

    function render() {
      var text = statusText();
      if (status.textContent.trim() !== text) status.textContent = text;
      if (bar && total > 0) {
        bar.style.width = Math.min(100, Math.round((shown / total) * 100)) + '%';
      }
      button.hidden = !nextUrl || failed || observer !== null;
    }

    function setBusy(on) {
      loading = on;
      root.classList.toggle('is-loading', on);
      if (on) grid.setAttribute('aria-busy', 'true');
      else grid.removeAttribute('aria-busy');
      button.disabled = on;
      button.textContent = on ? loadingLabel : moreLabel;
    }

    function stopAuto() {
      if (!observer) return;
      observer.disconnect();
      observer = null;
    }

    function append(fetchedGrid) {
      var seen = {};
      Array.prototype.forEach.call(grid.querySelectorAll('.product-card[data-product-id]'), function (card) {
        seen[card.getAttribute('data-product-id')] = true;
      });

      var added = [];
      Array.prototype.forEach.call(fetchedGrid.querySelectorAll('.product-card'), function (card) {
        if (card.parentElement && card.parentElement.closest('.product-card')) return;
        var id = card.getAttribute('data-product-id');
        if (id && seen[id]) return;
        if (id) seen[id] = true;
        Array.prototype.forEach.call(card.querySelectorAll('img'), function (img) {
          img.removeAttribute('fetchpriority');
          img.setAttribute('loading', 'lazy');
        });
        added.push(document.adoptNode(card));
      });

      var fragment = document.createDocumentFragment();
      added.forEach(function (card) { fragment.appendChild(card); });
      grid.appendChild(fragment);
      return added;
    }

    function focusFirstCard(cards) {
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].hidden || !cards[i].isConnected) continue;
        var link = cards[i].querySelector('.product-card__name') || cards[i].querySelector('a[href]');
        if (link) {
          link.focus();
          return true;
        }
      }
      return false;
    }

    function load(fromButton) {
      if (loading || !nextUrl) return;

      var requested = nextUrl;
      var url = sectionUrl(requested, sectionId);
      if (!url) {
        nextUrl = '';
        stopAuto();
        render();
        return;
      }

      failed = false;
      if (errorBox) errorBox.hidden = true;
      if (errorText) errorText.textContent = '';
      setBusy(true);

      fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fetchedGrid = doc.querySelector('[data-product-grid]');
          if (!fetchedGrid) throw new Error('No product grid in the response');

          var added = append(fetchedGrid);

          var fetchedNav = doc.querySelector('[data-pagination]');
          var fetchedRoot = doc.querySelector('[data-collection-pagination]');
          nextUrl = fetchedNav ? fetchedNav.getAttribute('data-next-url') || '' : '';
          if (nextUrl === requested) nextUrl = '';

          if (fetchedRoot) {
            total = toInt(fetchedRoot.dataset.total, total);
            shown = toInt(fetchedRoot.dataset.shown, shown + added.length);
          } else {
            shown += added.length;
          }
          if (total > 0) shown = Math.min(shown, total);

          setBusy(false);
          if (!nextUrl || autoLoaded >= autoPages) stopAuto();
          render();

          if (added.length) {
            document.dispatchEvent(new CustomEvent('theme:products-appended', {
              detail: { cards: added }
            }));
          }

          if (fromButton && !focusFirstCard(added)) {
            (nextUrl ? button : status).focus();
          }

          if (observer) {
            observer.unobserve(root);
            observer.observe(root);
          }
        })
        .catch(function () {
          setBusy(false);
          failed = true;
          stopAuto();
          render();
          if (errorBox) errorBox.hidden = false;
          if (errorText) errorText.textContent = errorMessage;
          if (fromButton && retry) retry.focus();
        });
    }

    nav.hidden = true;
    root.hidden = false;

    if (style === 'infinite' && autoPages > 0 && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        var near = entries.some(function (entry) { return entry.isIntersecting; });
        if (!near || loading || !nextUrl || autoLoaded >= autoPages) return;
        autoLoaded += 1;
        load(false);
      }, { rootMargin: ROOT_MARGIN });
      observer.observe(root);
    }

    button.addEventListener('click', function () { load(true); });
    if (retry) retry.addEventListener('click', function () { load(true); });

    render();
  }

  function init(container) {
    Array.prototype.forEach.call(
      (container || document).querySelectorAll('[data-collection-pagination]'),
      setup
    );
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) init(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
